import _ from 'lodash';
import {
  getSettingByKey,
  writeToLocalStorage,
  writeToSessionStorage,
} from '../util/configHelper';
import { observable, action } from 'mobx';
import { screenShareApi } from '../api/screen';

export class AppStore {
  @observable debugMenu: boolean;
  @observable showSettings: boolean;
  @observable
  connection: {
    host: string;
    port: string;
    terminalPort: string;
    vncPort: string;
    rtcAvailable: boolean;
  } = {
    host: '',
    port: '',
    terminalPort: '',
    vncPort: '',
    rtcAvailable: false,
  };
  @observable
  auth: {
    loggedIn: boolean;
    password: string;
  } = { loggedIn: false, password: '' };
  @observable
  crypto: {
    shook?: boolean;
    key?: string;
    iv?: string;
  } = {};
  @observable showPresenceToUser: boolean = false;

  constructor() {
    this.debugMenu = getSettingByKey('debug-menu');
    this.showSettings = getSettingByKey('show-settings');
    this.showPresenceToUser =
      getSettingByKey('show-presence-to-user') || this.showPresenceToUser;
  }

  @action
  handleSetRtc(rtcAvailable: boolean) {
    this.connection.rtcAvailable = rtcAvailable;
  }

  @action
  handleLogin(loggedIn: boolean) {
    this.auth.loggedIn = loggedIn;
  }

  @action
  handleSetPassword(password: string) {
    this.auth.password = password;
  }

  @action
  handleSetKey(key: KeyInfo) {
    _.assign(this.crypto, key);
  }

  @action
  handleSetShake(shook: boolean) {
    this.crypto.shook = shook;
  }

  @action
  handleSetHost(host: HostInfo) {
    _.assign(this.connection, host);
  }

  @action
  handleSetDebugMenu(enabled: boolean) {
    if (enabled) {
      this.debugMenu = true;
      writeToLocalStorage('debug-menu', true);
    } else {
      this.debugMenu = false;
      writeToLocalStorage('debug-menu', false);
    }
  }

  @action.bound
  changeShowPresenceToUser(showPresenceToUser: boolean) {
    this.showPresenceToUser = showPresenceToUser;

    // must not persist the flag across sessions
    writeToSessionStorage('show-presence-to-user', showPresenceToUser);

    screenShareApi.showPresenceToUser(showPresenceToUser);
  }
}

export const appStore = new AppStore();
